import React from 'react';
import './AdminPanel.css';
import { ShiftScheduleOptions } from '../constants/shiftOptions';
import { PositionOptions } from '../constants/positionOptions';
import { ACCOUNT_OPTIONS } from '../constants/accountOptions';

const RegisterEmployee = ({
  handleRegisterEmployee, photoBase64, fileInputRef, handleFileChange,
  newEmpId, setNewEmpId, newEmpEID, setNewEmpEID, newEmpName, setNewEmpName,
  newEmpDateHired, setNewEmpDateHired, newEmpPosition, setNewEmpPosition,
  newEmpShift, setNewEmpShift, newEmpAccount, setNewEmpAccount, error, successMsg
}) => {
  return (
    <div className="admin-form-wrapper">
      <div className="admin-form-panel" style={{ maxWidth: 680 }}>
        <h2 className="admin-form-title">New Employee</h2>
        <p className="admin-form-subtitle">Register a new workforce member with RFID credentials</p>

        {error && <div className="admin-alert admin-alert--error">{error}</div>}
        {successMsg && <div className="admin-alert admin-alert--success">{successMsg}</div>}

        <form onSubmit={handleRegisterEmployee}>
          <div className="admin-photo-section">
            <div className="admin-photo-box" onClick={() => fileInputRef.current?.click()}>
              {photoBase64 ? (
                <img src={photoBase64} alt="Preview" className="admin-photo-preview" />
              ) : (
                <span className="admin-photo-placeholder">2×2<br />PHOTO</span>
              )}
            </div>
            <label htmlFor="file-upload" className="admin-upload-btn">
              {photoBase64 ? 'Change Photo' : 'Upload 2×2 Photo'}
            </label>
            <input type="file" accept="image/*" ref={fileInputRef} onChange={handleFileChange} id="file-upload" required style={{ display: 'none' }} />
          </div>

          <div className="admin-form-grid-2col">
            <div className="admin-form-group">
              <label className="admin-form-label">Employee UID (RFID)</label>
              <input type="text" value={newEmpId} onChange={(e) => setNewEmpId(e.target.value)} placeholder="Scan RFID Tag" className="admin-form-input" required />
            </div>

            <div className="admin-form-group">
              <label className="admin-form-label">Employee EID</label>
              <input type="text" value={newEmpEID} onChange={(e) => setNewEmpEID(e.target.value)} placeholder="e.g. H-2025-001" className="admin-form-input" required />
            </div>

            <div className="admin-form-group admin-form-full-width">
              <label className="admin-form-label">Full Name</label>
              <input type="text" value={newEmpName} onChange={(e) => setNewEmpName(e.target.value)} placeholder="Enter Complete Name" className="admin-form-input" required />
            </div>

            <div className="admin-form-group">
              <label className="admin-form-label">Date Hired</label>
              <input type="date" value={newEmpDateHired} onChange={(e) => setNewEmpDateHired(e.target.value)} className="admin-form-input" required />
            </div>

            <div className="admin-form-group">
              <label className="admin-form-label">Position</label>
              <select value={newEmpPosition} onChange={(e) => setNewEmpPosition(e.target.value)} className="admin-form-input" required>
                <PositionOptions includeEmpty emptyLabel="-- Select Position --" />
              </select>
            </div>

            <div className="admin-form-group">
              <label className="admin-form-label">Account</label>
              <select value={newEmpAccount} onChange={(e) => setNewEmpAccount(e.target.value)} className="admin-form-input" required>
                {ACCOUNT_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </select>
            </div>

            <div className="admin-form-group admin-form-full-width">
              <label className="admin-form-label">Scheduled Shift</label>
              <select value={newEmpShift} onChange={(e) => setNewEmpShift(e.target.value)} className="admin-form-input" required>
                <option value="">-- Select Specific Schedule --</option>
                <ShiftScheduleOptions />
              </select>
            </div>

            <button type="submit" className="admin-submit-btn admin-form-full-width">
              Register Employee
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegisterEmployee;
